import { Component } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { selectEntrepriseProduct, selectFreeProduct, selectProProduct } from '../../store/products/products.selects';
import { BehaviorSubject, Observable } from 'rxjs';
import { Product } from '../../class/product.class';
import { PricingComponent } from "../../components/pricing/pricing.component";
import { ButtonComponent } from "../../components/boutons/button/button.component";
import { ResponsiveService } from '../../services/reponsive.service';
import { AsyncPipe, NgClass } from '@angular/common';
import { LoginService } from '../../services/login.service';
import { OpeningComponent } from "../../components/landingPage/opening/opening.component";
import { ActivatedRoute, Params, Router, RouterLink } from '@angular/router';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { AuthRegisterResponse } from '../../models/auth-register-response.model';
import { FooterComponent } from "../../components/footer/footer.component";

@Component({
    selector: 'app-landing-page',
    imports: [NavbarComponent, LucideAngularModule, TranslateModule, LucideAngularModule, PricingComponent, ButtonComponent, AsyncPipe, NgClass, OpeningComponent, FooterComponent],
    templateUrl: './landing-page.component.html',
    styleUrl: './landing-page.component.scss'
})
export class LandingPageComponent {

    // :🤳 Responsive
    smallScreen$: Observable<boolean> = this.responsiveService.small$
    mediumScreen$: Observable<boolean> = this.responsiveService.desktop$
    largeScreen$: Observable<boolean> = this.responsiveService.largeDesktop$;

    // 💰 Pricing
    currency$: BehaviorSubject<'EUR' | 'DOL'> = new BehaviorSubject<'EUR' | 'DOL'>('EUR');
    periodicity$: BehaviorSubject<'month' | 'year'> = new BehaviorSubject<'month' | 'year'>('month');
    free$: Observable<Product | null> = this.store.select(selectFreeProduct);
    pro$: Observable<Product | null> = this.store.select(selectProProduct);
    entreprise$: Observable<Product | null> = this.store.select(selectEntrepriseProduct);

    // 🖼️ Features
    features: { name: string, imgUrl: string }[] = [
        { name: 'Editez les traductions', imgUrl: 'https://i.imgur.com/KeUxkct.jpg' },
        { name: 'Génération de sous-titres', imgUrl: 'https://i.imgur.com/KeUxkct.jpg' },
        { name: 'Post-production des répliques', imgUrl: 'https://i.imgur.com/KeUxkct.jpg' },
    ]

    constructor(
        private responsiveService: ResponsiveService,
        private store: Store,
        private loginService: LoginService,
        private route:ActivatedRoute
    ) { }

    scrollToElement(element: HTMLElement) {
        element.scrollIntoView({ behavior: "smooth" });
    }

    ngOnInit() {
        this.route.queryParams.subscribe((params:Params) => {
            const code:string = params['code'];
            if (code) {
                this.loginService.sendGoogleAuthCode(code).subscribe({
                    next: (authRes:AuthRegisterResponse) => {
                        this.loginService.login(authRes)
                    }
                    , error: (error) => {
                        console.error(error);
                    }
                })
            }
        })
    }
}
